// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1WJx8","head":"ProcedureTableInfo_head__32Md9"};